import React, { useState } from 'react';
import { ShortcutListContainerProps } from './shortcutListProps';
import { ReportingContainerBaseConfig } from '../../../../../base';
import { ShortcutLoader, ShortcutController } from './shortcutListInterface';
import { assertNever } from '@varos/util-typescript';

export function createShortcutContainer(
    config: ReportingContainerBaseConfig,
    loader: ShortcutLoader,
    controller: ShortcutController
): React.FC<ShortcutListContainerProps> {
    const {
        kernel,
        context: { useContext },
        repository: { research: repository },
    } = config;
    return ({ as: View, ...containerProps }) => {
        const context = useContext();
        const data = loader.useLoad(context, containerProps);
        const [loadingComponentId, setLoadingComponentId] = useState<string | null>(null);

        const mutation = {
            form: {
                create: repository.form.useCreate(context),
            },
            document: {
                update: repository.document.useUpdate(context),
            },
        };

        const props = controller.useProps(context, data, {
            async onComponentCreate(component) {
                setLoadingComponentId(component.id);
                try {
                    if (component.kind === 'interview') {
                        console.log('creating interview');
                        const form = await mutation.form.create.mutateAsync({
                            title: 'New interview',
                            status: 'draft',
                            fields: [],
                        });
                        console.log('form created', form);
                        console.log('adding block');
                        const block = await mutation.document.update.mutateAsync([
                            containerProps.contentId,
                            {
                                icon: component.icon,
                                title: undefined,
                                blocks: [
                                    {
                                        kind: 'form',
                                        form: form.id,
                                    },
                                ],
                            },
                        ]);
                        console.log('block added', block);
                        return;
                    }
                    if (component.kind === 'form') {
                        console.warn('Form creation not implemented');
                        return;
                    }
                    if (component.kind === 'survey') {
                        console.warn('Survey creation not implemented');
                        return;
                    }
                    if (component.kind === 'collection') {
                        console.warn('Collection creation not implemented');
                        return;
                    }
                    assertNever(component.kind);
                } finally {
                    setLoadingComponentId(null);
                }
            },
            loadingComponentId,
        });
        return <View {...props} />;
    };
}
